<template>
  <div>
    <!--顶部工具条-->
    <el-col :span="24">
      <el-form :inline="true">
        <el-form-item style="margin-left: 20px">
          <toolbar
            :buttonList="buttonList"
            @callFunction="callFunction"
          ></toolbar>
        </el-form-item>
        <el-form-item>
         <el-button
            type="primary"
            @click="jumpPromotionSettingDetail()"
            >修改记录</el-button
          >
          </el-form-item>
      </el-form>
    </el-col>
    <!--列表-->
    <el-table
      :data="tableData"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%"
      border
      @current-change="selectCurrentRow"
      class="custom-padding-table"
    >
    <el-table-column
        prop="configKey"
        label="编号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="configName"
        label="配置名"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="configValue"
        label="值"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="description"
        label="配置说明"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="isEnable"
        label="是否启用"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          <el-tag type="info" v-if="scope.row.isEnable == 0">禁用</el-tag>
          <el-tag type="success" v-if="scope.row.isEnable == 1">启用</el-tag>
        </template>
      </el-table-column>
     
    </el-table>
 

    <!--订单新增区域新增界面-->
    <el-dialog
      :title="editmark == true ? '编辑' : '新增'"
      :visible.sync="FormVisible"
      v-model="FormVisible"
      :close-on-click-modal="false"
    >
      <div style="display: flex">
        <div class="left" style="flex: 1">
          <el-form
            :model="Form"
            label-width="100px"
            ref="Form"
            style="max-width: 700px"
            :rules="FormRules"
          >
            <el-form-item label="配置名：" prop="configName">
              <el-input
                v-model="Form.configName"
                auto-complete="off"
                placeholder="请输入标题"
              ></el-input>
            </el-form-item>
            <el-form-item label="值" prop="configValue">
              <el-input
                v-model="Form.configValue"
                auto-complete="off"
                placeholder="请输入值"
              ></el-input>
            </el-form-item>
            <el-form-item label="配置说明" prop="description">
              <el-input
                v-model="Form.description"
                auto-complete="off"
                placeholder="请输入配置说明"
              ></el-input>
            </el-form-item>
            <el-form-item label="编号" prop="configKey">
              <el-input
                v-model="Form.configKey"
                auto-complete="off"
                placeholder="请输入编号"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否启用：">
              <el-radio-group v-model="Form.isEnable">
                <el-radio :label="true">启用</el-radio>
                <el-radio :label="false">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="FormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="FormSubmit"
          :loading="listLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import util from "../../../util/date";
import {
  getPointList,
  addUserPoint,
  updateUserPoint,
  deleteUserPoint
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import Qs from "qs";
export default {
  components: { Toolbar },
  data() {
    return {
      util: "",
      tableData: [],
      listLoading: false,
      //增删改查按钮
      buttonList: [],
      FormVisible: false,
      Form: {
        configName: "",
        configValue: "",
        description: "",
        configKey: "",
        isEnable: true,
      },
      FormRules: {
        configName: [
          { required: true, message: "请输入配置名", trigger: "blur" },
        ],
        configValue: [{ required: true, message: "请选择值", trigger: "blur" }],
        description: [
          { required: true, message: "请选择配置说明", trigger: "blur" },
        ],
        configKey: [{ required: true, message: "请选择编号", trigger: "blur" }],
      },
      currentRow: "",
      editmark: false,
    };
  },
  methods: {
    
    jumpPromotionSettingDetail() {
      this.$router.push({
        path: "/PointsSettingsRevisionHistory"
      });
    },
    getList() {
      getPointList().then((res) => {
        this.tableData = res.data.response;
      });
    },
  
    selectCurrentRow(row) {
      this.currentRow = row;
    },

    async handleEdit() {
      if (!this.currentRow) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      // 等待 DOM 渲染完成再调用 resetFields
      this.$nextTick(() => {
        if (this.$refs.Form) {
          this.$refs.Form.resetFields();
        }
      });
      this.editmark = true;
      // 深拷贝一下
      this.Form = {
        configName: this.currentRow.configName,
        configValue: this.currentRow.configValue,
        description: this.currentRow.description,
        configKey: this.currentRow.configKey,
        isEnable: this.currentRow.isEnable,
      };
      this.FormVisible = true;
    },
    handleAdd() {
      // 等待 DOM 渲染完成再调用 resetFields
      this.$nextTick(() => {
        if (this.$refs.Form) {
          this.$refs.Form.resetFields();
        }
      });
      this.editmark = false;
      this.Form = {
        configName: "",
        configValue: "",
        description: "",
        configKey: "",
        isEnable: true,
      };
      this.FormVisible = true;
    },

    //提交新增表单
    FormSubmit() {
      this.$refs.Form.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.listLoading = true;
            let params = [{
              ...this.Form,
            }];
            if (this.editmark) {
              params[0].id = this.currentRow.id
              updateUserPoint(params).then((res) => {
                if (res.data.success) {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.$refs["Form"].resetFields();
                  this.FormVisible = false;
                  this.getList();
                } else {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
            } else {
              addUserPoint(params).then((res) => {
                if (res.data.success) {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.$refs["Form"].resetFields();
                  this.FormVisible = false;
                  this.getList();
                } else {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
            }
          });
        }
      });
    },

     handleDel() {
      if (!this.currentRow) {
        this.$message({
          message: "请选择要删除的的一行数据！",
          type: "error",
        });
        return;
      }
      this.$confirm("确认删除吗？", "提示", {}).then(() => {
        this.listLoading = true;
        let params = {
          Id: this.currentRow.id,
        };
        deleteUserPoint(params).then((res) => {
          if (res.data.success) {
            this.listLoading = false;
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getList();
            this.$refs["Form"].clearValidate();
            this.FormVisible = false;
          } else {
            this.listLoading = false;
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        });
      });
    },

    formatCreateTime: function (date) {
      return !date || date == ""
        ? ""
        : util.formatDate.format(new Date(date), "yyyy-MM-dd hh:mm:ss");
    },
    // apply改变this指向
    callFunction(item) {
      this[item.func].apply(this, item);
    }
  },
  mounted() {
    this.getList();
    this.util = util;
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>
<style lang="stylus" scoped>
.rolesTop {
  width: 100%;
  display: flex;
}

.rolesInp {
  width: 300px;
  margin-right: 20px;
}

.pageBar {
  margin-top: 15px;
}

/* 👇👇👇 新增的样式开始 👇👇👇 */
.custom-padding-table {
  ::v-deep .el-table__cell {
    /* 上下内边距，根据需要调整数值，默认通常是 8px 或 10px */
    padding-top: 16px;
    padding-bottom: 16px;
  }

  /* 如果上面的写法在某些构建环境下不生效，可以尝试加 !important 强制覆盖 */
  ::v-deep td.el-table__cell {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
}

/* 👆👆👆 新增的样式结束 👆👆👆 */
.no-margin-form-item {
  ::v-deep .el-form-item__content {
    margin-left: 0px !important;
  }
}

.no-left {
  ::v-deep .el-form-item__content .el-form-item__error {
    left: 30px !important;
    width: 110px !important;
  }
}
</style>
